import { useEffect, useState } from 'react';

import getSellers from '../api/graphql/queries/getSellers';

const transformDataToSelectOptions = (options) => {
  if (!Array.isArray(options)) return null;
  return options.map(({ sellerSlugName, sellerName }) => ({ label: sellerName, value: sellerSlugName }));
};

const useSellers = (formatOptions) => {
  const [sellers, setSellers] = useState(null);

  useEffect(() => {
    getSellers().then((res) => {
      const options = formatOptions ? transformDataToSelectOptions(res) : res;
      console.log('options', options);
      setSellers(options);
    });
  }, []);
  return [sellers];
};

export default useSellers;
